import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckAccessToken } from '@mdd/api';
import { PrincipalService } from '../principal.service';
import { createRouterLocation } from './createRouterLocation';
import { ReloginGuard } from './relogin.guard';

@Injectable()
export class LoginGuard extends ReloginGuard {
    private checkAccessToken = new CheckAccessToken();

    constructor(
        location: Location,
        private route: ActivatedRoute,
        private router: Router,
        principal: PrincipalService
    ) {
        super(location, principal);
    }

    canLoad(): boolean {
        if (this.checkAccessToken.execute(createRouterLocation(this.route.snapshot, this.router))) {
            // Access token is valid, but do they need to relogin?
            return super.canLoad();
        }

        this.router.navigate(['/login'], {
            queryParams: {
                redirect_path: this.location.path() || undefined
            }
        });

        return false;
    }
}
